//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { find } from "lodash";

//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const bookListSelecter = (state) => state.booksAllList;
const bookOrderSelecter = (state) => state.bookOrder;
const bookListActiveInActiveSelecter = (state) => state.booksActiveInActive;
//  -- Examples array selector --------

export const useAllBook = () => {
    const selectedData = useSelector(bookListSelecter, shallowEqual);
    return selectedData;
};

export const useBookOrder = () => {
    const selectedData = useSelector(bookOrderSelecter, shallowEqual);
    return selectedData;
};
/**
 * 
 * @returns 
 * const int_book_allowed = {
  allowed_book: [],
  other_permissions: {
    "one_informate": true,
    "comunidad": true,
    "balcon": true,
    "conectandome": true,
    "ap": true,
    "story": true,
    "exam": true,
    "resourses": true
  },
  books_group: [],
  externalLinkBooks:[],
  extra_books:[]
}
 */
export const useUserAllowedBooks = () => {
    const selectedData = useSelector(state=>state.userAllowedBooks, shallowEqual);
    return selectedData;
};

export const useDistrictActiveBooks = () => {
    const booksAllList = useAllBook();
    const userAllowedBooks = useUserAllowedBooks();
    const bookOrder = useBookOrder();
    return useMemo(() => {
        const list = Array.isArray(booksAllList) ? booksAllList : [];
        const idSet = new Set();
        const addId = (id) => {
            if (id != null && id !== "") {
                idSet.add(String(id));
            }
        };
        (userAllowedBooks?.allowed_book || []).forEach(addId);
        (userAllowedBooks?.extra_books || []).forEach(addId);
        (userAllowedBooks?.externalLinkBooks || []).forEach(addId);
        const groups = userAllowedBooks?.books_group || [];
        groups.forEach((key) => {
            const order = find(bookOrder || [], ["key", key]);
            (order?.order || []).forEach(addId);
        });
        if (idSet.size === 0) {
            return list.filter((b) => b && (b.active === undefined || b.active === true));
        }
        return list.filter((b) => b && idSet.has(String(b.id)));
    }, [booksAllList, userAllowedBooks, bookOrder]);
};

export const useBooksCover = () => {
    const selectedData = useSelector(state=>state.booksCoverList, shallowEqual);
    return selectedData;
};
